
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.594 12.631l.461-.457a.755.755 0 00.153-.195c-.362-.024-.733-.195-1.043-.504-.733-.733-.728-1.775 0-2.508l1.966-1.96c.728-.733 1.77-.738 2.504-.005.737.742.737 1.784.004 2.512l-.88.871c.095.343.095.71.033 1.061l1.423-1.432c1.043-1.042 1.052-2.527-.005-3.588-1.056-1.056-2.541-1.047-3.584-.005L8.585 8.463c-1.043 1.042-1.052 2.526.004 3.583.305.309.652.514 1.005.585zM5.79 14.848c1.056 1.057 2.541 1.047 3.588 0l2.038-2.036c1.047-1.047 1.056-2.532 0-3.588-.31-.31-.657-.51-1.005-.585l-.47.47a.777.777 0 00-.144.186c.362.024.733.196 1.043.505.733.733.728 1.775-.005 2.507l-1.961 1.96c-.728.734-1.775.738-2.504.006-.733-.748-.737-1.78-.004-2.513l.88-.875a2.326 2.326 0 01-.033-1.057L5.79 11.256c-1.047 1.047-1.062 2.531 0 3.592z","fill":"#000C1F","stroke":"#000C1F","stroke-width":".5"}})])
          )
        }
      }
    